import { images } from "../../Constants/imageslinks.js";

function Header() {
  return (
    <div className="bg-primary100">
      <div className="3xl:container 3xl:mx-auto">
        <div className="md:py-[45px] py-5 lg:px-[3.88vw] 3xl:px-[75px] md:px-8 px-4">
          <img
            src={images.minimis_logo}
            alt="minimis logo"
            className="md:max-w-[179px] max-w-[126px]"
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
